import { useMutation, useQueryClient } from "@tanstack/react-query";

import { callApi } from "../utils/ApiCallPostOnly";

export const useSaveAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "shipmentaddresscard",
        command: "save",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shipmentaddresslist"] });
    },
  });
};
